export default __webpack_public_path__ + "static/media/keto-bars-box@3x.244a6c0c.png";